import { TColor } from '../../type/color';

const COLORS: { [key: string]: TColor } = {
	PRIMARY: 'primary',
	SECONDARY: 'secondary',
	INFO: 'info',
	WARNING: 'warning',
	DANGER: 'danger',
	SUCCESS: 'success',
	LIGHT: 'light',
	DARK: 'dark',
};
export default COLORS;
